// extracted by mini-css-extract-plugin
export default {"blankNav":"blankNav-1PCeh","mainContainer":"mainContainer-1NabS","header":"header-3_mbu"};